import React from 'react';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import SalesMngCostStatsContainer from '../../containers/sales_mng_cost_stats/SalesMngCostStatsContainer';

const SalesMngCostStatsPage = () => {
  return (
    <div>
      <BreadcrumbsContainer
        title="판관비 관리/판매관리비 통계"
        icon="statistics"
      />
      <SalesMngCostStatsContainer />
    </div>
  );
};

export default SalesMngCostStatsPage;
